<template>
  <div class="diff-block">
    <div v-if="title" class="diff-block-header">
      <code>{{ title }}</code>
    </div>
    <div class="diff-block-content">
      <div v-for="(chunk, index) in split_content" :key="index">
        <component
          :is="component"
          :styled="false"
          :class="
            chunk.startsWith('+')
              ? 'plus'
              : chunk.startsWith('-')
                ? 'minus'
                : chunk.startsWith('$')
                  ? 'command'
                  : chunk.startsWith('#')
                    ? 'comment'
                    : ''
          "
        >
          {{ chunk.substring(1).replace(/\s/g, "&nbsp;") }}
        </component>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title?: string;
  content: string;
}>();

const split_content = computed(() => props.content.split("\n"));
const component = computed(() => (split_content.value.length > 1 ? "code" : resolveComponent("SelectableCode")));
</script>

<style scoped>
.diff-block {
  @apply w-full bg-zinc-900 border border-zinc-700 rounded-md text-gray-400;

  .diff-block-header {
    @apply text-xs font-semibold text-gray-200 border-b border-zinc-700 px-3 py-2 overflow-auto;
  }

  .diff-block-content {
    @apply px-4 py-2 text-sm overflow-auto;

    .plus {
      @apply text-green-500;

      &::before {
        @apply content-['+'] ml-[-10px] mr-[2px];
      }
    }

    .minus {
      @apply text-red-500;

      &::before {
        @apply content-['-'] ml-[-10px] mr-[2px];
      }
    }

    .command {
      @apply text-gray-200;

      &::before {
        @apply content-['$'] ml-[-5px] mr-[8px] text-gray-400;
      }
    }

    .comment {
      @apply text-gray-400;

      &::before {
        @apply content-['#'] ml-[-5px] mr-[8px];
      }
    }
  }
}
</style>
